/**
 * Password Validation Utility
 *
 * Requirements:
 * - Minimum length: 8 characters
 * - Maximum length: 32 characters
 * - At least one uppercase letter (A-Z)
 * - At least one lowercase letter (a-z)
 * - At least one number (0-9)
 * - At least one symbol/special character (e.g. !@#$%^&*()_+-=[]{};':"|,.<>/?~)
 */

export function validatePassword(password = "") {
  const str = String(password || "");

  const minLength = str.length >= 8;
  const maxLength = str.length <= 32;
  const hasUpper = /[A-Z]/.test(str);
  const hasLower = /[a-z]/.test(str);
  const hasNumber = /[0-9]/.test(str);
  const hasSymbol = /[^A-Za-z0-9]/.test(str);

  const errors = [];
  if (!str) {
    errors.push("Password is required.");
  } else {
    if (!minLength) errors.push("Password must be at least 8 characters long.");
    if (!maxLength) errors.push("Password must not exceed 32 characters.");
    if (!hasUpper) errors.push("Password must contain at least one uppercase letter (A-Z).");
    if (!hasLower) errors.push("Password must contain at least one lowercase letter (a-z).");
    if (!hasNumber) errors.push("Password must contain at least one number (0-9).");
    if (!hasSymbol) errors.push("Password must contain at least one symbol.");
  }

  const isValid = minLength && maxLength && hasUpper && hasLower && hasNumber && hasSymbol;

  return {
    isValid,
    errors,
    checks: {
      minLength,
      maxLength,
      hasUpper,
      hasLower,
      hasNumber,
      hasSymbol,
    },
  };
}
